import request from '@/utils/request'

// 用户登录
export function login(data) {
    return request({
        url: '/api/v1/user/login/',
        method: 'post',
        data: {
            phone_number: data.phone_number,
            password: data.password
        }
    })
}

// 退出登录
export function logout() {
    return request({
        url: '/api/v1/user/logout/',
        method: 'post'
    })
}

// 用户注册
export function register(data) {
    return request({
        url: '/api/v1/user/userInfo/register/',
        method: 'post',
        data: {
            phone_number: data.phone_number,
            password: data.password,
            invitation_code: data.invite_code
        }
    })
}
